<template>
  <div class="table-container">
    <table class="table hide-medium" border="0" cellspacing="0" cellpadding="0" style="border-radius: 8px; overflow: hidden">
      <thead class="table-header">
        <tr v-if="tableValues.length">
          <th class="table-header-item">{{ setDate(docType) }}</th>
          <th v-if="hasDecisions && docType === 1" class="table-header-item wide">{{ $t('kbisUpdates') }}</th>
          <th v-else-if="hasDecisions" class="table-header-item wide">{{ $t('decision') }}</th>
          <th v-if="docType === 4" class="table-header-item wide">{{ $t('closureDate') }}</th>
          <th class="table-header-item"></th>
        </tr>
        <tr v-else>
          <th class="table-header-item"></th>
        </tr>
      </thead>

      <tbody class="table-content">
        <tr v-for="item in tableValues" :key="item.publicId" class="table-line">
          <td class="table-item" :class="{ read: item.read }">
            <div class="item">{{ $utils.formatDate(item.publishedDate) }}</div>
          </td>
          <td v-if="hasDecisions" class="table-item wide">
            <div class="item">{{ item.typeDecisions.type }}</div>
            <div v-if="item.typeDecisions.decisions && item.typeDecisions.decisions.length > 0" class="item decision">
              <div v-for="decision in item.typeDecisions.decisions" :key="decision">{{ decision }}</div>
            </div>
          </td>
          <td v-if="docType === 4" class="table-item" :class="{ read: item.read }">
            <div class="item">
              {{ !item.closingDate || item.closingDate === '0001-01-01T00:00:00' ? '' : $utils.formatDate(item.closingDate) }}
            </div>
          </td>
          <td
            v-if="
              !(docType === 4 && (item.confidentialInformation === 'CONFIDENTIALITE_COMPTE_RESULTAT' || item.confidentialInformation === 'CONFIDENTIEL')) ||
              (user.client && user.client.confidentialAccess)
            "
            class="table-item"
          >
            <div class="item">
              <div v-if="item.status === 1" style="margin-left: auto; display: inline-flex; gap: 4px; align-items: center; justify-content: flex-end">
                <div class="lds-ring" style="transform: scale(0.75); width: 32px; height: 32px">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>

                <span style="font-size: 14px">{{ $t('retrievalInProgress') }}</span>
              </div>

              <span v-else-if="item.status === 2" class="link-button" style="font-size: 14px" @click="() => readDocument(item.publicId)">
                {{ item.isRead ? $t('visualizeAgain') : $t('visualize') }}
              </span>

              <div
                v-else-if="item.status === 3 || item.status === 4"
                style="margin-left: auto; display: flex; flex-direction: column; text-align: end; gap: 4px"
              >
                <span style="color: #f9626b; font-size: 14px">{{ $t('retrievalInError') }}</span>
                <span class="link-button" style="font-size: 14px" @click="() => $router.push({ name: 'contact' })">{{ $t('contactUs') }}</span>
              </div>
            </div>
          </td>
          <td v-else class="table-item">
            <div class="item confidential">
              <span>
                {{ $t('confidentiel') }}
              </span>
            </div>
          </td>
        </tr>
        <tr v-if="!tableValues.length" class="table-line">
          <td class="table-item" :class="{ read: true }">
            <div class="item center">{{ $t('noDocuments') }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="table-container show-medium">
      <div v-if="!tableValues.length" class="">{{ $t('noDocuments') }}</div>

      <div v-for="item in tableValues" :key="item.publicId" class="table-line" style="display: flex; flex-direction: column !important; gap: 8px">
        <div class="line">
          <div class="line-content">
            <div class="item">{{ $utils.formatDate(item.publishedDate) }}</div>
          </div>
        </div>

        <div v-if="hasDecisions" class="line" style="font-size: 14px">
          <div class="line-content">
            <div class="item">{{ item.typeDecisions.type }}</div>
          </div>
        </div>

        <div class="line">
          <div
            v-if="
              !(docType === 4 && (item.confidentialInformation === 'CONFIDENTIALITE_COMPTE_RESULTAT' || item.confidentialInformation === 'CONFIDENTIEL')) ||
              (user.client && user.client.confidentialAccess)
            "
            class="line-content"
          >
            <div class="item" style="justify-content: flex-end">
              <div v-if="item.status === 1" style="margin-left: auto; display: inline-flex; gap: 4px; align-items: center; justify-content: flex-end">
                <div class="lds-ring" style="transform: scale(0.75); width: 32px; height: 32px">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>

                <span style="font-size: 12px">{{ $t('retrievalInProgress') }}</span>
              </div>

              <span v-else-if="item.status === 2" class="link-button" style="font-size: 12px" @click="() => readDocument(item.publicId)">
                {{ item.isRead ? $t('visualizeAgain') : $t('visualize') }}
              </span>

              <div
                v-else-if="item.status === 3 || item.status === 4"
                style="margin-left: auto; display: flex; flex-direction: column; text-align: end; gap: 4px"
              >
                <span style="color: #f9626b; font-size: 12px">{{ $t('retrievalInError') }}</span>
                <span class="link-button" style="font-size: 12px" @click="() => $router.push({ name: 'contact' })">{{ $t('contactUs') }}</span>
              </div>
            </div>
          </div>
          <div v-else class="line-content">
            <div class="item confidential">
              <span>
                {{ $t('confidentiel') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Pagination :pagination="pagination" :set-page="setPage" :tableValues="tableValues" :pages="pages" :disable-dots="disableDots" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pagination from '@/components/Pagination';
import tableMixin from '@/components/tables/TableMixin';

export default {
  components: { Pagination },
  mixins: [tableMixin],

  props: {
    fakeData: {
      type: Array,
      required: true,
    },

    docType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      headers: [this.$t('creationDate'), this.$t('decisions'), ''],
      values: [],
      tableMixinConfig: {
        disablePagination: true,
        backendPaginated: false,
        onChange: this.changePage,
        getData: this.getData,
      },
    };
  },

  computed: {
    ...mapGetters(['user']),

    hasDecisions() {
      return this.values.filter(e => e.typeDecisions.type || (this.docType === 1 && e.typeDecisions.decisions)).length > 0;
    },
  },

  async mounted() {
    this.values = this.fakeData;

    const pageLength = Math.ceil(this.fakeData.length / 5);
    if (pageLength > 1) this.pagination.maxPage = pageLength;
  },

  methods: {
    async readDocument(publicId) {
      const result = await this.$store.dispatch('getCompanyPdf', { publicId });
      window.open(result.url, '_blank');
    },

    setDate(docType) {
      switch (docType) {
        case 1:
          return this.$t('kbisDate');
        case 2:
          return this.$t('statusDate');
        case 4:
          return this.$t('depositDate');
        case 8:
          return this.$t('depositDate');
        default:
          return this.$t('creationDate');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';

.table-container {
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-chevron,
    .number {
      cursor: pointer;
      width: 22px;
      height: 22px;
      margin: 0 10px;

      &:hover {
        color: colors.$lightblue-color;
      }

      &.disabled {
        cursor: not-allowed;
        color: rgba(colors.$lightgrey-color, 0.5) !important;

        &:after {
          border-color: rgba(colors.$lightgrey-color, 0.5) !important;
        }
      }
    }

    .number {
      color: colors.$grey-color;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.current {
        background: colors.$lightblue-color;
        color: colors.$white-color;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .header {
    margin: 60px 0 0;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: flex-end;
      font-weight: 500;
      font-size: 20px;
    }

    .main-button {
      max-width: 200px;
      padding: 0;
    }
  }
}

.table .table-content .table-line {
  background: colors.$white-color;

  &.empty .table-item .item {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: colors.$lightgrey-color;
    font-size: 14px;
    font-style: italic;
  }

  &:last-child .table-item {
    border: none;
  }

  .table-header-item {
    width: 25%;
    &.wide {
      width: 50%;
    }
  }

  .table-item {
    border-bottom: 1px solid colors.$border-color;
    background: transparent;
    width: 25%;

    &.wide {
      width: 50%;
    }

    &:last-child .item span {
      width: 100%;
      text-align: right;
    }

    .item {
      color: colors.$darkgrey-color;
      font-size: 13px;
      font-weight: normal;
      display: flex;
      justify-content: space-between;

      &.center {
        justify-content: center;
      }

      &.confidential {
        text-transform: capitalize;
      }

      &.decision {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        opacity: 0.6;

        div {
          font-size: 11px;
          margin-top: 2px;

          &::before {
            content: '-';
            margin-right: 4px;
          }
        }
      }
    }

    &.read {
      .item {
        color: colors.$black-color;
        font-weight: 500;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-medium) {
  .table-container {
    width: 100%;

    .table-line {
      width: 100%;

      flex-direction: row !important;
      height: unset !important;
      justify-content: space-between !important;

      margin: 12px 0;
      display: flex;
      flex-direction: column;

      background: colors.$unread-table-color;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 4px;

      .line {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .line-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          .item {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
      }
    }
  }
}
</style>
